var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"card",class:{
      active: step.active,
      curr: step.curr
    }},[_c('div',{staticClass:"indicator"},[_c('i'),(index < _vm.steps.length - 1)?_c('div',{staticClass:"bar",class:{
          zero: !step.active,
          half: step.curr,
          full: step.active && _vm.steps[index + 1] && _vm.steps[index + 1].active
        }}):_vm._e()]),_c('div',{staticClass:"status"},[_vm._v(_vm._s(step.describe))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(step.time),expression:"step.time"}],staticClass:"date"},[_vm._v(_vm._s(step.time))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }